<template>
  <div class="card-body">
    <div class="fs-6 fw-bold text-center text-primary mb-5 my-4">
      <!-- logo otomatis dari backend / fallback -->
      <img :src="preview" alt="Logo Klinik" height="100">
      <div
        class="fs-2 mt-2 fw-normal text-dark"
      >Silakan buat kata sandi baru yang kuat untuk melindungi akun Anda.</div>
    </div>
    <form>
      <div class="mb-4">
        <label for="exampleInputPassword1" class="form-label">Kata Sandi Baru *</label>
        <input
          v-model="form.password"
          type="password"
          class="form-control"
          id="exampleInputPassword1"
          placeholder="Kata Sandi Baru..."
          autocomplete="off"
        >
      </div>
      <div class="mb-4">
        <label for="exampleInputPassword2" class="form-label">Konfirmasi Kata Sandi *</label>
        <input
          v-model="form.confirm_password"
          type="password"
          class="form-control"
          id="exampleInputPassword2"
          placeholder="Konfirmasi Kata Sandi..."
          autocomplete="off"
        >
      </div>
      <div class="d-flex align-items-center justify-content-between mb-4">
        <div class="form-check"></div>
        <router-link to="/login" class="text-primary fw-bold">Kembali ke halaman Masuk</router-link>
      </div>
      <button
        type="button"
        class="btn btn-primary w-100 py-8 fs-4 mb-4 rounded-2 liveToastBtn"
      >Ubah Sandi</button>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import config from '../config'

export default {
	metaInfo: {
		titleTemplate: 'Reset Password'
	},
	data() {
		return {
			logoUrl: require('@/assets/logo_dzikri.png'), // default lokal
			form: {
				password: null,
				confirm_password: null,
				vcode: ''
			},
			isSent: false,
			errors: []
		}
	},
	computed: {
		...mapGetters({
			conf: 'location/getConfig'
		}),
		preview: {
			// getter
			get() {
				let url = ''
				if (this.conf && this.conf.logo) {
					url = config('api.baseUrl') + '/storage/uploads/' + this.conf.logo
				} else {
					url = this.logoUrl
				}
				return url
			},
			set(value) {
				this.conf.logo = value
			}
		}
	},
	methods: {
		...mapActions('auth', ['changepass']),
		onSubmit: function() {
			this.changepass({
				new_password: this.form.new_password,
				confirm_password: this.form.confirm_password,
				vcode: this.form.vcode
			})
				.then((res) => {
					var myModal = new bootstrap.Modal(document.getElementById('reset_password'))
					myModal.show()
					let toast = this.$toasted.show(`${res.respond.response}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
				})
				.catch((err) => {
					console.log('vue===========', err)
				})
		}
	},
	created() {
		// console.log(this.$route.params)
	}
}
</script>
